(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('DesktopCertificationController',DesktopCertificationController);

    DesktopCertificationController.$inject = ['$scope'];

    function DesktopCertificationController($scope) {
        var vm = this;

        vm.appraiser = $scope.vm.appraisalOrder.appraiser;
        vm.appraiserUser = $scope.vm.appraiserUser;

        vm.appraiserCertification = [
            vm.appraiserUser.designationCRA ? 'CRA P.App' : null,
            vm.appraiserUser.designationAACI ? 'AACI P.App' : null,
            vm.appraiserUser.credentials
        ].filter(Boolean).join(', ');
    }
})();
